import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { compose, pure } from 'recompose';
import { fetchCatalogIfNeeded } from 'catalog/actions/catalog';
import PageLoader from 'common/components/PageLoader';

const mapStateToProps = state => {
  const { catalog } = state;
  const { isFetching, root } = catalog;

  return {
    isFetching,
    root,
  };
};
const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchCatalog: () => dispatch(fetchCatalogIfNeeded(ownProps.route.catalog)),
});
class CoreLayout extends React.Component {
  static propTypes = {
    children: PropTypes.element.isRequired,
    isFetching: PropTypes.bool,
    root: PropTypes.object,
    route: PropTypes.object,
    fetchCatalog: PropTypes.func.isRequired,
  };

  componentWillMount() {
    this.props.fetchCatalog();
  }

  get content() {
    return React.cloneElement(this.props.children, {
      catalog: this.props.route.catalog,
    });
  }

  render() {
    const { root, isFetching } = this.props;
    if (isFetching || !root) {
      return <PageLoader title="Chargement du catalogue" />;
    }

    return <div>{this.content}</div>;
  }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), pure)(
  CoreLayout
);



// WEBPACK FOOTER //
// ./src/modules/catalog/layouts/CoreLayout.js